import { Button, Icon, Popup } from "semantic-ui-react";
import { Link } from "react-router-dom";
import "./AttendanceItem.scss";
import moment from "moment";

export function AttendanceItem(props) {
  const { academicCycle } = props;

  const getColor = (status) => {
    switch (status) {
      case 1:
        return "blue"; // Color para Preinscripción
      case 2:
        return "green"; // Color para Iniciado
      case 3:
        return "red"; // Color para Finalizado
      default:
        return "gray"; // Color por defecto
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 1:
        return "PREINSCRIPCIÓN";
      case 2:
        return "INICIADO";
      case 3:
        return "FINALIZADO";
      default:
        return "DESCONOCIDO";
    }
  };

  return (
    <div className="attendance-item">
      <div className="attendance-item__info">
        <span className="attendance-item__info-title">
          {academicCycle.Level.name} - {academicCycle.name}
        </span>
        <span className="attendance-item__info-start-date">
          <b>Fecha de inicio:</b>{" "}
          {moment.utc(academicCycle.startDate).format("DD/MM/YYYY")}
        </span>
        <span className="attendance-item__info-end-date">
          <b>Fecha de fin:</b>{" "}
          {moment.utc(academicCycle.endDate).format("DD/MM/YYYY")}
        </span>
      </div>
      <div>
        <Popup
          content="Asistencia general"
          trigger={
            <Button
              icon
              color="blue"
              as={Link}
              to={`/admin/attendance/${academicCycle.id}/general`}
            >
              <Icon name="check circle" />
            </Button>
          }
        />
        {/* <Popup
          content="Asistencia por clase"
          trigger={
            <Button
              icon
              color="green"
              as={Link}
              to={`/admin/attendance/${academicCycle.id}/class`}
            >
              <Icon name="calendar check" />
            </Button>
          }
        /> */}
      </div>
    </div>
  );
}